angular.module("Main").controller("NutzungrechteMemberController", ["$rootScope", "$scope", "$location", "$window", "$state", "$cookies", "$uibModal", "$uibModalInstance", "AuthenticationService", "BookingService",
    function ($rootScope, $scope, $location, $window, $state, $cookies, $uibModal, $uibModalInstance, AuthenticationService, BookingService) {
        var vm = this;
        vm.text = $stateParams.text;
        vm.isTermin = !$stateParams.isKurs;
        vm.isKurs = !!$stateParams.isKurs;

        getKursbuchungLayouKonfiguration();
        loadLandingPageBSConfig();


        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        function loadLandingPageBSConfig() {
            BookingService.loadLandingPageBSConfig().then(function (data) {
                vm.landingPage = data;
                if (vm.landingPage.LandingPageBuchungssystem) {
                    if (window.location !== window.parent.location) {
                        if (_.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "http") || _.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "https")) {
                            vm.landingPageWithout = true;
                        } else {
                            vm.landingPageWith = true;
                        }

                        // The page is in an iframe
                    } else {
                        if (_.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "http") || _.startsWith("https", vm.landingPage.LandingPageUrlBuchungssystem, "https")) {
                            vm.landingPageNewTabWithout = true;
                        } else {
                            vm.landingPageNewTabWith = true;
                        }
                        // The page is not in an iframe
                    }
                }
            })
        }

        if (!SessionService.getSessionId()) {
            if (vm.isKurs) {
                $state.go("kursplan", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
            }
            if (!vm.isKurs) {
                $state.go('angebot', {cid: $stateParams.cid, id: $stateParams.id});
            }
        }

        let logoutHandler = $rootScope.$on("logout", function () {
            SessionService.clear('globals', 'meetingData', 'meetingDate', 'kursData');
            if (vm.isKurs) {
                $state.go('kursplan', {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
            }
            if (!vm.isKurs) {
                $state.go('angebot', {cid: $stateParams.cid, id: $stateParams.id});
            }
        });
        $scope.$on("destroy", function () {
            logoutHandler();
        });

    }]);